import { renderDate } from '../utility/personTabGridHelper';

export const CREDENTIAL_TYPE = {
  SSN: 'SSN',
  OLN: 'OLN',
};

export const DEFAULT_VALUES = {
  Type: '',
  Number: '',
  State: '',
  Class: '',
  IsCommercial: false,
  ptsIssuedByID: null,
  Issued: null,
  Expiration: null,
  Description: '',
  Notes: '',
};

export const CREDENTIAL_GRID_COLUMNS = [
  { field: 'Type', headerName: 'Type', width: 160 },
  { field: 'Number', headerName: 'Number', width: 200 },
  { field: 'Created', headerName: 'Created', width: 180, valueFormatter: renderDate },
  { field: 'CreatedBy', headerName: 'Created By', width: 160 },
  { field: 'Updated', headerName: 'Updated', width: 180, valueFormatter: renderDate },
  { field: 'UpdatedBy', headerName: 'Updated By', width: 160 },
];
